'use strict';

var $ = require('jquery');
require('jquery-datetimepicker');

function init() {
	var	$warrantyForm = $('#warrantyRegistrationForm');
	if (!$warrantyForm.length)
		return;

	function applyPicker() {
		var $dateEl = $('input[id*="dateInstalled"]');
		$dateEl.datetimepicker({
			timepicker: false,
			format: 'm/d/Y'
		});
	}

	applyPicker();
	$(document).on('jsfAjaxAlways', applyPicker)
}

module.exports = {
	init: init
}